export default {
  frontRoutes: [
    {
      path: '/community',
      name: 'Community',
      component: () =>
        // import(
        //   /* webpackChunkName: "community" */
        //   "../views/community/Community.vue"
        // ),
        import(
          /* webpackChunkName: "community" */
          '@/components/community/Community.vue'
        ),
    },
    {
      path: '/community/community-show/:id/',
      name: 'CommunityShow',
      component: () =>
        import(
          /* webpackChunkName: "community" */
          '@/components/community/CommunityShow.vue'
        ),
    },
    {
      path: '/community/community-detail/:id/:group_id/:type',
      name: 'CommunityDetail',
      component: () =>
        import(
          /* webpackChunkName: "community" */
          '@/components/community/CommunityDetail.vue'
        ),
    },
    {
      path: '/community/group',
      name: 'CommunityGroup',
      component: () =>
        import(
          /* webpackChunkName: "community" */
          '@/components/community/CommunityGroup.vue'
        ),
    },
    {
      path: '/community/group-show/:id/',
      name: 'CommunityGroupShow',
      component: () =>
        import(
          /* webpackChunkName: "community" */
          '@/components/community/CommunityGroupShow.vue'
        ),
    },
    {
      path: '/community/community-post',
      name: 'CommunityPost',
      component: () =>
        import(
          /* webpackChunkName: "community" */
          '@/components/community/CommunityPost.vue'
        ),
    },
  ],
  memberRoutes: [
    {
      path: '/member/mcommunity',
      name: 'MemberCommunity',
      component: () =>
        import(
          /* webpackChunkName: "member" */
          '@/components/community/MemberCommunity.vue'
        ),
      meta: {
        requireAuth: true,
        title: '我的圈子',
        root: true,
      },
    },
  ],
};
